import React, { useState, useCallback } from 'react';
import { KfsInputs } from '../types/kfs.types';
import { useKfsCalculator } from '../hooks/useKfsCalculator';
import KfsInputForm from './KfsInputForm';
import KfsSummaryPanel from './KfsSummaryPanel';
import KfsInstalmentTable from './KfsInstalmentTable';
import KfsPrintLayout from './KfsPrintLayout';
import IconSystem from 'icon-collection/icon-systems';
import './KfsCalculator.css';

function getToday(): Date {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

const INITIAL_INPUTS: KfsInputs = {
  loanAmount: null,
  loanDate: getToday(),
  interestRate: null,
  grossWeight: null,
};

const KfsCalculatorPage: React.FC = () => {
  const [inputs, setInputs] = useState<KfsInputs>(INITIAL_INPUTS);
  const { values, isValid, errors } = useKfsCalculator(inputs);

  const handleReset = useCallback(() => {
    setInputs({ ...INITIAL_INPUTS, loanDate: getToday() });
  }, []);

  const handlePrint = useCallback(() => {
    window.print();
  }, []);

  return (
    <div className="module-master-container">
      <div className="kfs-page-wrapper">
        {/* Page Header */}
        <div className="kfs-page-header">
          <div className="kfs-header-icon">
            <IconSystem.calculator size={18} color="#fff" />
          </div>
          <div className="kfs-header-text">
            <h2>Gold Loan — Key Fact Statement Calculator</h2>
            <p>Calculate and preview all KFS-derived values as per RBI regulations</p>
          </div>
        </div>

        {/* Main Content: 2 columns */}
        <div className="kfs-content-grid">
          {/* Left Column: Inputs */}
          <div className="kfs-left-column">
            <KfsInputForm inputs={inputs} onChange={setInputs} errors={errors} />
            <KfsInstalmentTable dates={values?.instalmentDueDates ?? null} />
          </div>

          {/* Right Column: Summary */}
          <KfsSummaryPanel values={values} />
        </div>

        {/* Action Bar */}
        <div className="kfs-actions">
          <button className="btn btn-secondary" onClick={handleReset}>
            <IconSystem.refresh size={15} />
            Reset
          </button>
          <button className="btn btn-primary" onClick={handlePrint} disabled={!isValid}>
            <IconSystem.print size={15} />
            Print / PDF
          </button>
        </div>
      </div>

      <KfsPrintLayout inputs={inputs} values={values} />
    </div>
  );
};

export default KfsCalculatorPage;
